module.exports = __webpack_public_path__ + "img/feature_buy_zh.a89fb23a.png";